import type { ComponentProps } from "react";

import {
  CreditAmountSelector,
  CreditLimitReachedAlert,
  InsufficientCreditAlert,
} from "@/features/referral/components";
import type { Credit, CreditAmount } from "@/features/referral/models";

interface CreditOptionsProps {
  credit: Credit;
  value: CreditAmount | undefined;
  onChange: ComponentProps<typeof CreditAmountSelector>["onChange"];
}

export const CreditOptions = ({
  credit,
  value,
  onChange,
}: CreditOptionsProps) => {
  const canApplyCreditAmount =
    credit.available > 0 && !credit.hasReachedMonthlyLimit;
  const hasReachedCreditAmountLimit =
    credit.hasReachedMonthlyLimit && credit.available > 0;

  return (
    <>
      {canApplyCreditAmount && (
        <CreditAmountSelector
          value={value}
          onChange={onChange}
          options={credit.options}
        />
      )}

      {hasReachedCreditAmountLimit && <CreditLimitReachedAlert />}

      {!credit.available && <InsufficientCreditAlert />}
    </>
  );
};
